var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#27D639"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6784 19.289C20.6913 19.289 22.323 17.6573 22.323 15.6445C22.323 13.6317 20.6913 12 18.6784 12C16.6656 12 15.0339 13.6317 15.0339 15.6445C15.0339 17.6573 16.6656 19.289 18.6784 19.289Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 25.9675L12.2353 24.6636C12.5133 23.1577 13.3101 21.7969 14.4871 20.8173C15.6642 19.8378 17.1471 19.3016 18.6784 19.3018V19.3018C20.2115 19.3021 21.696 19.8402 22.8733 20.8222C24.0506 21.8043 24.8461 23.1681 25.1215 24.6763L25.3569 25.9802",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenAvatar);
export default __webpack_public_path__ + "static/media/greenAvatar.cee5add1878f575d5762b2ea1214775c.svg";
export { ForwardRef as ReactComponent };